module.exports = "<div id=\"app-container\">\n    <app-help-drawer *ngIf=\"!isFullscreen && isAuthenticate\"></app-help-drawer>\n    <app-main-header *ngIf=\"!isFullscreen\"></app-main-header>\n\n    <app-main-left-column *ngIf=\"!isFullscreen && isAuthenticate\"></app-main-left-column>\n\n    <app-main-view *ngIf=\"isAuthenticate\"></app-main-view>\n\n    <app-authentication *ngIf=\"needAuthentication && !isAuthenticate\"></app-authentication>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main